var exports = {
  "iE": "EmbedCard.module__wrapper___WThROH",
  "p_": "EmbedCard.module__splashWrapper___WThROH",
  "Yi": "EmbedCard.module__splash___WThROH",
  "Vg": "EmbedCard.module__grid___WThROH",
  "iA": "EmbedCard.module__iconSlot___WThROH",
  "Qs": "EmbedCard.module__content___WThROH",
  "wx": "EmbedCard.module__header___WThROH",
  "$": "EmbedCard.module__titleRow___WThROH",
  "VA": "EmbedCard.module__subtitle___WThROH",
  "rf": "EmbedCard.module__body___WThROH",
  "yF": "EmbedCard.module__divider___WThROH",
  "DD": "EmbedCard.module__title___WThROH",
  "N4": "EmbedCard.module__titleButton___WThROH",
  "jn": "EmbedCard.module__titlePrimary___WThROH",
  "S3": "EmbedCard.module__titleDanger___WThROH",
  "BK": "EmbedCard.module__helpText___WThROH",
  "_O": "EmbedCard.module__iconCircleDisabled___WThROH",
  "m5": "EmbedCard.module__iconError___WThROH",
  "qV": "EmbedCard.module__skeleton___WThROH",
  "U6": "EmbedCard.module__pulse___WThROH",
  "mj": "EmbedCard.module__skeletonCircle___WThROH",
  "Iz": "EmbedCard.module__skeletonTitle___WThROH",
  "wS": "EmbedCard.module__skeletonSubtitle___WThROH",
  "VR": "EmbedCard.module__skeletonIcon___WThROH",
  "X1": "EmbedCard.module__skeletonDot___WThROH",
  "gH": "EmbedCard.module__skeletonStat___WThROH",
  "Ye": "EmbedCard.module__skeletonStatShort___WThROH",
  "KJ": "EmbedCard.module__skeletonStatLong___WThROH",
  "G3": "EmbedCard.module__skeletonButton___WThROH",
};

module.exports = exports;
